"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const react_1 = __importDefault(require("react"));
const input_styles_1 = require("../input.styles");
const Toggle = (props) => {
    const { type, checked, onChange = () => { } } = props;
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    return (react_1.default.createElement(input_styles_1.ToggleElement, { colors: colors, theme: theme },
        react_1.default.createElement("input", { type: type, id: "switch", className: "checkbox", checked: checked, onChange: onChange }),
        react_1.default.createElement("label", { htmlFor: "switch", className: "toggle" })));
};
exports.default = Toggle;
//# sourceMappingURL=toggle.js.map